import { render, staticRenderFns } from "./SalaryTemplatesSave.vue?vue&type=template&id=d943080e"
import script from "./SalaryTemplatesSave.vue?vue&type=script&lang=js"
export * from "./SalaryTemplatesSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports